import React, { useEffect, useMemo, useRef } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd';

interface LogoUploadProps {
  value?: UploadFile[];
  onChange?: (fileList: UploadFile[]) => void;
}

const LogoUpload: React.FC<LogoUploadProps> = ({ value, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const file = value?.[0]?.originFileObj;

  const previewUrl = useMemo(
    () => (file !== undefined ? URL.createObjectURL(file) : ''),
    [file],
  );

  useEffect(() => {
    return () => {
      if (previewUrl !== '') URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  const openPicker = () => {
    inputRef.current?.click();
  };

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const picked = e.target.files?.[0];
    e.target.value = '';
    if (picked === undefined) return;
    onChange?.([
      {
        uid: `${Date.now()}`,
        name: picked.name,
        status: 'done',
        originFileObj: picked as UploadFile['originFileObj'],
      },
    ]);
  };

  return (
    <div className="logo-upload">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleSelect}
      />
      {previewUrl !== '' ? (
        <div className="logo-upload__tile logo-upload__tile--filled">
          <img src={previewUrl} alt="Organization logo" />
          <div className="logo-upload__actions">
            <button type="button" aria-label="Change logo" onClick={openPicker}>
              <PlusOutlined />
            </button>
            <button
              type="button"
              aria-label="Remove logo"
              onClick={() => {
                onChange?.([]);
              }}
            >
              <DeleteOutlined />
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="logo-upload__tile logo-upload__btn"
          onClick={openPicker}
        >
          <PlusOutlined />
          <span>Upload logo</span>
        </button>
      )}
    </div>
  );
};

export default LogoUpload;
